module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside.a768b00a.svg";